import { Navigate } from "react-router-dom";

/**
 * ProtectedRoute - Component to protect routes based on user role
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - The component to render if access is allowed
 * @param {number} props.allowedRoleId - The role_id that is allowed to access this route (4 for Doctor, 5 for Pharmacy)
 * @param {string} props.redirectTo - The path to redirect to if access is denied
 */
const ProtectedRoute = ({ children, allowedRoleId, redirectTo }) => {
  const storedRoleId = sessionStorage.getItem("usr_role_id");
  const roleId = storedRoleId ? parseInt(storedRoleId, 10) : null;

  // If no role_id is stored, redirect to login
  if (!roleId) {
    return <Navigate to="/" replace />;
  }

  // If role_id doesn't match, redirect to appropriate dashboard
  if (roleId !== allowedRoleId) {
    return <Navigate to={redirectTo} replace />;
  }

  // Access granted
  return children;
};

export default ProtectedRoute;
